export const imports = {};
import * as react from 'react';
import * as components from '/home/runner/work/react-showroom/react-showroom/examples/react-example/src/components/index.ts';
import * as reactShowroom__client from 'react-showroom/client';
import * as classnames from 'classnames';
imports.react = react;
imports.components = components;
imports.reactShowroom__client = reactShowroom__client;
imports.classnames = classnames;
